<template>
  <v-dialog max-width="600px" v-model="dialog" @keydown.enter.prevent="save">
    <v-card>
      <v-card-title>
        <span class="headline">Boost Config</span>
      </v-card-title>
      <v-card-text>
        <v-row dense>
          <v-col cols="12" sm="4" md="4">
            <r-item-boost-mode :model.sync="mode"/>
          </v-col>
        </v-row>
        <v-row dense class="mt-3">
          <v-col cols="12" sm="12" md="12" v-if="mode.id !== 0">
            <r-item-boost-rule-table :items="model.rules" title="Rules"/>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn @click="cancel" color="blue darken-1" text>Cancel</v-btn>
        <v-btn @click="save" color="blue darken-1" text>Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>


import {ViewRules} from "@/common/ViewRules";
import {ItemBoostMode} from "@/modules/redactor/models/item/boost/ItemBoostMode";
import {ItemBoostConfig} from "@/modules/redactor/models/item/boost/ItemBoostConfig";

import RItemBoostMode from "@/modules/redactor/views/item/boost/r-item-boost-mode.vue";
import RItemBoostRuleTable from "@/modules/redactor/views/item/boost/r-item-boost-rule-table.vue";


export default {
  name: "r-item-boost-config",
  components: {RItemBoostRuleTable, RItemBoostMode},
  data: () => ({
    dialog: false,
    resolve: null,
    reject: null,
    model: new ItemBoostConfig(),
    rules: ViewRules.READONLY,
    panels: []
  }),
  computed: {
    mode: {
      get: function () {
        return this.model ? this.model.mode : ItemBoostMode.DISABLED;
      },
      set: function (value) {
        this.model.mode = value;
      }
    }
  },
  methods: {
    show(rules, model) {
      this.dialog = true;
      this.rules = rules;
      this.model = model || new ItemBoostConfig();
      this.panels = [];
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    save() {
      if (this.model.empty()) {
        this.resolve(null);
        this.discard();
      } else if (this.model.valid()) {
        this.resolve(this.model);
        this.discard();
      } else {
        this.$alert("Invalid config!");
      }
    },
    cancel() {
      this.reject();
      this.discard();
    },
    discard() {
      this.dialog = false;
    }
  }
}
</script>